<div class="flex flex-column w-12 mx-0 sm:text-base text-sm">
  <p-panel>
    <ng-template pTemplate="header">
      <div class="text-center" style="width: 95%">
        <span class="my-0 py-0 font-weight-normal"
          >Spatial Validation Result files</span
        >
      </div>
    </ng-template>

    @if (
      !fileError() && !dataFetchError() && updatedMetrics$ | async;
      as metrics
    ) {
      <div
        style="min-height: 400px"
        class="flex flex-column align-content-center justify-content-center"
      >
        @if (
          selectedMetric() && selectedMetric().boxplotFiles | async;
          as boxplots
        ) {
          <div class="flex flex-column w-12 flex-wrap gap-2">
            <!-- metric selector + download buttons -->
            <div
              class="flex flex-row w-12 align-content-center justify-content-center my-2 py-3 lg:flex-nowrap flex-wrap gap-2"
            >
              <div
                class="flex flex-column lg:w-6 w-10 flex-wrap justify-content-center align-content-center gap-4"
              >
                <div class="flex flex-column w-10">
                  <p-floatLabel>
                    <p-select
                      id="spatialMetricSelector"
                      (onChange)="onMetricChange($event)"
                      [options]="metrics"
                      [ngModel]="selectedMetric()"
                      optionLabel="metric_pretty_name"
                      [style]="{ width: '100%' }"
                    >
                    </p-select>
                    <label for="spatialMetricSelector">Select metric</label>
                  </p-floatLabel>
                </div>
              </div>
              <div
                class="flex flex-row lg:w-6 w-10 lg:flex-nowrap flex-wrap justify-content-center align-content-center gap-2"
              >
                <div
                  class="flex flex-column lg:w-5 w-10 justify-content-center"
                >
                  <button
                    pButton
                    type="button"
                    icon="pi pi-download"
                    class="btn-action-large"
                    label="Download graphs"
                    pTooltip="Download spatial graphs .zip"
                    [life]="globals.tooltipLifetime"
                    (click)="downloadSpatialGraphics()"
                  ></button>
                </div>
                <div
                  class="flex flex-column lg:w-5 w-10 justify-content-center"
                >
                  <button
                    pButton
                    type="button"
                    icon="pi pi-download"
                    class="btn-action-large"
                    label="Download NetCDF"
                    pTooltip="Download spatial results in NetCDF format"
                    [life]="globals.tooltipLifetime"
                    (click)="downloadSpatialNetCDF()"
                  ></button>
                </div>
              </div>
            </div>
            <hr class="flex w-11 pt-0 mt-0 featurette-divider" />
            <div
              class="flex flex-row w-12 justify-content-center align-content-center md:text-4xl text-2xl text-muted"
            >
              Spatial Plots
              <span
                class="pi pi-question-circle mx-2 text-2xl"
                pTooltip="Boxplot shows metric distribution across all stations. Overview map shows how many points were used."
                tooltipPosition="bottom"
              >
              </span>
            </div>
            @if (selectedMetric().overviewFiles | async; as overviewPlots) {
              <div class="flex flex-column w-12 gap-3 py-3">
                <!-- boxplot + overview maps -->
                <div
                  class="flex flex-row lg:flex-nowrap flex-wrap w-12 align-content-center justify-content-center gap-3"
                >
                  <!-- boxplot -->
                  @if (boxplots.length > 0) {
                    <div
                      [ngClass]="{
                        'flex flex-column align-items-center justify-content-center plot-spot': true,
                        'w-10': overviewPlots.length === 0,
                        'lg:w-5 w-10': overviewPlots.length > 0,
                      }"
                    >
                      <p-galleria
                        [value]="boxplots"
                        [(visible)]="displayBoxplotGallery"
                        [(activeIndex)]="activeBoxplotIndex"
                        [circular]="true"
                        [fullScreen]="true"
                        [showItemNavigators]="false"
                        [showThumbnails]="false"
                        [baseZIndex]="100000"
                      >
                        <ng-template pTemplate="item" let-item>
                          <img
                            [src]="sanitizePlotUrl(item.plot)"
                            style="width: 100%; display: block"
                            alt="Boxplot for {{
                              selectedMetric().metric_pretty_name
                            }}"
                          />
                        </ng-template>
                      </p-galleria>
                      <img
                        width="85%"
                        style="object-fit: contain"
                        [src]="sanitizePlotUrl(boxplots[0].plot)"
                        (click)="showGallery(0, 'boxplot')"
                        [ngClass]="{ 'result-plot': true }"
                        alt="Boxplot for {{
                          selectedMetric().metric_pretty_name
                        }}"
                      />
                    </div>
                  }
                  <!-- overview maps -->
                  <div
                    class="flex flex-row flex-wrap lg:w-6 w-10 align-content-center justify-content-center gap-3"
                  >
                    @for (plot of overviewPlots; track plot; let ind = $index) {
                      <div
                        [ngClass]="{
                          'image-container': true,
                          'w-12': overviewPlots.length === 1,
                          'w-10': overviewPlots.length === 2,
                          'w-5': overviewPlots.length > 2,
                        }"
                      >
                        <span class="image-label">{{
                          selectedMetric().datasets[ind]
                        }}</span>
                        <p-galleria
                          [value]="overviewPlots"
                          [(visible)]="displayOverviewGallery"
                          [(activeIndex)]="activeOverviewIndex"
                          [circular]="true"
                          [fullScreen]="true"
                          [showItemNavigators]="overviewPlots.length > 1"
                          [showThumbnails]="false"
                          [baseZIndex]="100000"
                        >
                          <ng-template pTemplate="item" let-item>
                            <img
                              [src]="sanitizePlotUrl(item.plot)"
                              style="width: 100%; display: block"
                              alt="Overview map"
                            />
                          </ng-template>
                        </p-galleria>
                        <img
                          width="95%"
                          style="object-fit: contain"
                          [src]="sanitizePlotUrl(plot.plot)"
                          (click)="showGallery(ind, 'overview')"
                          [ngClass]="{ 'result-plot': true, pcol: true }"
                          alt="Overview map for {{
                            selectedMetric().metric_pretty_name
                          }}"
                        />
                      </div>
                    }
                  </div>
                </div>
                <!-- tsplot -->
                @if (selectedMetric().tsplotFiles | async; as tsplots) {
                  <div>
                    @if (tsplots.length > 0) {
                      <div
                        class="flex flex-column w-12 align-items-center justify-content-center plot-spot mt-3"
                      >
                        <p-galleria
                          [value]="tsplots"
                          [(visible)]="displayTsplotGallery"
                          [(activeIndex)]="activeTsplotIndex"
                          [circular]="true"
                          [fullScreen]="true"
                          [showItemNavigators]="false"
                          [showThumbnails]="false"
                          [baseZIndex]="100000"
                        >
                          <ng-template pTemplate="item" let-item>
                            <img
                              [src]="sanitizePlotUrl(item.plot)"
                              style="width: 100%; display: block"
                              alt="Time series for {{
                                selectedMetric().metric_pretty_name
                              }}"
                            />
                          </ng-template>
                        </p-galleria>
                        <span class="text-muted mb-2" style="font-size: 1rem"
                          >Time series</span
                        >
                        <img
                          width="95%"
                          style="object-fit: contain"
                          [src]="sanitizePlotUrl(tsplots[0].plot)"
                          (click)="showGallery(0, 'tsplot')"
                          [ngClass]="{ 'result-plot': true, pcol: true }"
                          alt="Time series for {{
                            selectedMetric().metric_pretty_name
                          }}"
                        />
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    @if (dataFetchError() || fileError()) {
      <div class="p-3">
        <p class="lead text-muted">
          Spatial result plots are temporarily unavailable.
        </p>
      </div>
    }
  </p-panel>
</div>
